import i18n from "@microdoing/shared/i18n";
import { Box, MainText } from "app/components/common";
import React from "react";
import { widthPercentageToDP } from "react-native-responsive-screen";

const SeparatorCoaching = ({}) => {
  return (
    <Box
      marginTop="m"
      marginBottom="l"
      position="relative"
      width={widthPercentageToDP("90%")}
      alignItems="center"
      justifyContent="center"
    >
      <Box backgroundColor="neutral.75" zIndex={2}>
        <MainText color="neutral.700" paddingHorizontal="xxs">
          {i18n.t("coaching-details")}
        </MainText>
      </Box>
      <Box
        width={widthPercentageToDP("90%")}
        left={0}
        position="absolute"
        height={1}
        backgroundColor="neutral.200"
        zIndex={-1}
      />
    </Box>
  );
};

export default SeparatorCoaching;
